export const price = [
  {
    "id": "1",
    "title": "Product-01",
    "price": "60 120",
    "category_id": "1",
    "date": "2023-06-29 12:43:27"
  },
  {
    "id": "2",
    "title": "Product-21",
    "price": "61 120",
    "category_id": "2",
    "date": "2023-06-29 12:44:48"
  },
  {
    "id": "3",
    "title": "1С:Бухгалтерия 8 для Казахстана. Электронная поставка",
    "price": "64 800",
    "category_id": "2",
    "date": "2023-07-04 19:19:56"
  },
  {
    "id": "4",
    "title": "1С:Бухгалтерия 8 для Казахстана. Электронная поставка",
    "price": "77800",
    "category_id": "8",
    "date": "2024-09-10 21:09:30"
  },
  {
    "id": "5",
    "title": "1С:Бухгалтерия 8 для Казахстана. Базовая версия. Электронная поставка",
    "price": "25900",
    "category_id": "8",
    "date": "2024-09-10 21:10:07"
  },
  {
    "id": "6",
    "title": "1С:Предприятие 8. Управление торговлей для Казахстана. Электронная поставка",
    "price": "109000",
    "category_id": "8",
    "date": "2024-09-10 21:10:22"
  },
  {
    "id": "7",
    "title": "1С:Предприятие 8. Управление торговлей для Казахстана. Базовая версия. Электронная поставка",
    "price": "36300",
    "category_id": "8",
    "date": "2024-09-10 21:10:50"
  },
  {
    "id": "8",
    "title": "1С:Предприятие 8. Розница для Казахстана. Электронная поставка",
    "price": "77800",
    "category_id": "8",
    "date": "2024-09-10 21:11:17"
  },
  {
    "id": "9",
    "title": "1С:Предприятие 8. Розница для Казахстана. Базовая версия. Электронная поставка",
    "price": "25900",
    "category_id": "8",
    "date": "2024-09-10 21:11:30"
  },
  {
    "id": "10",
    "title": "1С:Предприятие 8. Управление нашей фирмой для Казахстана. Электронная поставка",
    "price": "109000",
    "category_id": "8",
    "date": "2024-09-10 21:11:48"
  },
  {
    "id": "11",
    "title": "1С:Предприятие 8. Управление нашей фирмой для Казахстана. Базовая версия. Электронная поставка",
    "price": "36300",
    "category_id": "8",
    "date": "2024-09-10 21:11:57"
  },
  {
    "id": "12",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных предприятий Казахстана. Электронная поставка",
    "price": "77800",
    "category_id": "8",
    "date": "2024-09-10 21:12:06"
  },
  {
    "id": "13",
    "title": "1С:Бюджетное планирование и финансирование для Казахстана. Электронная поставка",
    "price": "132000",
    "category_id": "8",
    "date": "2024-09-10 21:12:15"
  },
  {
    "id": "14",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных учреждений Казахстана. Электронная поставка",
    "price": "93400",
    "category_id": "8",
    "date": "2024-09-10 21:12:26"
  },
  {
    "id": "15",
    "title": "1С:Предприятие 8. Зарплата и кадры для государственных организаций Казахстана. Электронная поставка",
    "price": "109000",
    "category_id": "8",
    "date": "2024-09-10 21:12:36"
  },
  {
    "id": "16",
    "title": "1С:Предприятие 8. Свод отчетов для Казахстана. Электронная поставка",
    "price": "648000",
    "category_id": "8",
    "date": "2024-09-10 21:12:45"
  },
  {
    "id": "17",
    "title": "1С:Предприятие 8. Зарплата и Управление Персоналом для Казахстана. Электронная поставка",
    "price": "109000",
    "category_id": "8",
    "date": "2024-09-10 21:12:57"
  },
  {
    "id": "18",
    "title": "1С:Бухгалтерия 8 для Казахстана. Комплект на 5 пользователей. Электронная поставка",
    "price": "181500",
    "category_id": "8",
    "date": "2024-09-10 21:13:09"
  },
  {
    "id": "19",
    "title": "1С:Предприятие 8. Управление нашей фирмой для Казахстана. Комплект на 5 пользователей. Электронная поставка",
    "price": "203000",
    "category_id": "8",
    "date": "2024-09-10 21:13:18"
  },
  {
    "id": "20",
    "title": "1С:Предприятие 8. Управление торговым предприятием для Казахстана. Электронная поставка",
    "price": "576000",
    "category_id": "8",
    "date": "2024-09-10 21:13:28"
  },
  {
    "id": "21",
    "title": "1С:Предприятие 8. Комплексная автоматизация 8 для Казахстана. Редакция 2. Электронная поставка",
    "price": "504000",
    "category_id": "8",
    "date": "2024-09-10 21:13:37"
  },
  {
    "id": "22",
    "title": "1С:Предприятие 8. Документооборот КОРП для Казахстана. Электронная поставка",
    "price": "1152000",
    "category_id": "8",
    "date": "2024-09-10 21:13:49"
  },
  {
    "id": "23",
    "title": "1С:Предприятие 8. Зарплата и Управление персоналом КОРП для Казахстана. Электронная поставка",
    "price": "604800",
    "category_id": "8",
    "date": "2024-09-10 21:14:03"
  },
  {
    "id": "24",
    "title": "1С:Предприятие 8. ERP Управление предприятием 2 для Казахстана. Электронная поставка",
    "price": "3000000",
    "category_id": "8",
    "date": "2024-09-10 21:14:14"
  },
  {
    "id": "25",
    "title": "Защищенный программный комплекс 1С:Предприятие 8.3k. Электронная поставка для Казахстана",
    "price": "390000",
    "category_id": "8",
    "date": "2024-09-10 21:14:24"
  },
  {
    "id": "26",
    "title": "1С:Предприятие 8. Управление торговлей для Казахстана",
    "price": "118000",
    "category_id": "9",
    "date": "2024-09-10 21:15:44"
  },
  {
    "id": "27",
    "title": "1С:Бухгалтерия 8 для Казахстана",
    "price": "84300",
    "category_id": "9",
    "date": "2024-09-10 21:16:01"
  },
  {
    "id": "28",
    "title": "1С:Бухгалтерия 8 для Казахстана. Комплект на 5 пользователей",
    "price": "196600",
    "category_id": "9",
    "date": "2024-09-10 21:16:23"
  },
  {
    "id": "29",
    "title": "1С:Предприятие 8. Зарплата и Управление персоналом для Казахстана",
    "price": "118000",
    "category_id": "9",
    "date": "2024-09-10 21:16:36"
  },
  {
    "id": "30",
    "title": "1С:Предприятие 8. Зарплата и Управление Персоналом КОРП для Казахстана",
    "price": "655200",
    "category_id": "9",
    "date": "2024-09-10 21:16:46"
  },
  {
    "id": "31",
    "title": "1С:Предприятие 8. Управление нашей фирмой для Казахстана",
    "price": "118000",
    "category_id": "9",
    "date": "2024-09-10 21:16:58"
  },
  {
    "id": "32",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных учреждений Казахстана",
    "price": "101100",
    "category_id": "9",
    "date": "2024-09-10 21:17:18"
  },
  {
    "id": "33",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных учреждений Казахстана. Комплект на 5 пользователей",
    "price": "215300",
    "category_id": "9",
    "date": "2024-09-10 21:17:35"
  },
  {
    "id": "34",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных предприятий Казахстана",
    "price": "84300",
    "category_id": "9",
    "date": "2024-09-10 21:18:00"
  },
  {
    "id": "35",
    "title": "1С:Предприятие 8. Зарплата и кадры для государственных организаций Казахстана",
    "price": "118000",
    "category_id": "9",
    "date": "2024-09-10 21:18:17"
  },
  {
    "id": "36",
    "title": "1С:Комплексная автоматизация 8 для Казахстана. Редакция 2",
    "price": "546000",
    "category_id": "9",
    "date": "2024-09-10 21:18:30"
  },
  {
    "id": "37",
    "title": "1С:Комплексная автоматизация 8 для Казахстана на 10 пользователей + клиент-сервер. Редакция 2",
    "price": "975000",
    "category_id": "9",
    "date": "2024-09-10 21:19:08"
  },
  {
    "id": "38",
    "title": "1С:Предприятие 8. Конфигурация «Модуль «Бюджетирование» для 1С:КА 8 для Казахстана»",
    "price": "455000",
    "category_id": "9",
    "date": "2024-09-10 21:19:18"
  },
  {
    "id": "39",
    "title": "1С:Предприятие 8. Комплект прикладных решений на 5 пользователей для Казахстана",
    "price": "308900",
    "category_id": "9",
    "date": "2024-09-10 21:19:28"
  },
  {
    "id": "40",
    "title": "1С:Предприятие 8. ERP Управление предприятием 2 для Казахстана",
    "price": "3250000",
    "category_id": "9",
    "date": "2024-09-10 21:19:40"
  },
  {
    "id": "41",
    "title": "1С:ERP Управление предприятием 2 для Казахстана. Корпоративная поставка",
    "price": "20800000",
    "category_id": "9",
    "date": "2024-09-10 21:19:52"
  },
  {
    "id": "42",
    "title": "1С:ERP Управление предприятием 2 для Казахстана. Лицензия для дочерних обществ и филиалов",
    "price": "1235000",
    "category_id": "9",
    "date": "2024-09-10 21:20:05"
  },
  {
    "id": "43",
    "title": "1С:Предприятие 8. Управление холдингом для Казахстана",
    "price": "7722000",
    "category_id": "9",
    "date": "2024-09-10 21:20:20"
  },
  {
    "id": "44",
    "title": "1С:Предприятие 8. Управление холдингом для Казахстана. Лицензия для дочерних обществ и филиалов",
    "price": "1170000",
    "category_id": "9",
    "date": "2024-09-10 21:20:38"
  },
  {
    "id": "45",
    "title": "1С:Предприятие 8. Розница для Казахстана",
    "price": "84300",
    "category_id": "9",
    "date": "2024-09-10 21:21:30"
  },
  {
    "id": "46",
    "title": "1С:Предприятие 8. Свод отчетов для Казахстана",
    "price": "702000",
    "category_id": "9",
    "date": "2024-09-10 21:21:48"
  },
  {
    "id": "47",
    "title": "1С:Предприятие 8.3. Технологическая поставка",
    "price": "101400",
    "category_id": "9",
    "date": "2024-09-10 21:22:08"
  },
  {
    "id": "48",
    "title": "1С:Документооборот 8 ПРОФ",
    "price": "По запросу",
    "category_id": "9",
    "date": "2024-09-10 21:23:08"
  },
  {
    "id": "49",
    "title": "1С:Документооборот 8 КОРП",
    "price": "1248000",
    "category_id": "9",
    "date": "2024-09-10 21:23:23"
  },
  {
    "id": "50",
    "title": "Защищенный программный комплекс 1С:Предприятие 8.3k для Казахстана",
    "price": "422500",
    "category_id": "9",
    "date": "2024-09-10 21:23:36"
  },
  {
    "id": "51",
    "title": "1С:Бухгалтерия 8 для Казахстана. Учебная версия. Редакция 3.0",
    "price": "4500",
    "category_id": "10",
    "date": "2024-09-11 12:19:14"
  },
  {
    "id": "52",
    "title": "1С:Предприятие 8.3. Версия для обучения программированию",
    "price": "4 890",
    "category_id": "10",
    "date": "2024-09-11 12:29:17"
  },
  {
    "id": "53",
    "title": "1С:Бухгалтерия 8 для Казахстана. Базовая версия",
    "price": "28 100",
    "category_id": "10",
    "date": "2024-09-11 12:30:06"
  },
  {
    "id": "54",
    "title": "1С:Предприятие 8. Розница для Казахстана. Базовая версия",
    "price": "28 100",
    "category_id": "10",
    "date": "2024-09-11 12:30:41"
  },
  {
    "id": "55",
    "title": "1С:Предприятие 8. Управление нашей фирмой для Казахстана. Базовая версия",
    "price": "39 300",
    "category_id": "10",
    "date": "2024-09-11 12:31:28"
  },
  {
    "id": "56",
    "title": "1C:Предприятие 8. Управление торговлей для Казахстана. Базовая версия",
    "price": "39 300",
    "category_id": "10",
    "date": "2024-09-11 12:32:17"
  },
  {
    "id": "57",
    "title": "1С:Бухгалтерия 8 для Казахстана (USB)",
    "price": "99 200",
    "category_id": "10",
    "date": "2024-09-11 12:32:53"
  },
  {
    "id": "58",
    "title": "1С:Бухгалтерия 8 для Казахстана. Комплект на 5 пользователей.(USB)",
    "price": "211 500",
    "category_id": "10",
    "date": "2024-09-11 12:33:23"
  },
  {
    "id": "59",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных предприятий Казахстана (USB)",
    "price": "99 200",
    "category_id": "10",
    "date": "2024-09-11 12:33:56"
  },
  {
    "id": "60",
    "title": "1С:Предприятие 8. Бухгалтерский учет для государственных учреждений Казахстана (USB)",
    "price": "116 000",
    "category_id": "10",
    "date": "2024-09-11 12:34:34"
  },
  {
    "id": "61",
    "title": "1C:Предприятие 8. Розница для Казахстана. (USB)",
    "price": "99 200",
    "category_id": "10",
    "date": "2024-09-11 12:35:38"
  },
  {
    "id": "62",
    "title": "1С:Предприятие 8. Зарплата и Управление Персоналом для Казахстана (USB)",
    "price": "133 000",
    "category_id": "10",
    "date": "2024-09-11 12:36:14"
  },
  {
    "id": "63",
    "title": "1С:Предприятие 8. Управление торговлей для Казахстана (USB)",
    "price": "133 000",
    "category_id": "10",
    "date": "2024-09-11 12:36:46"
  },
  {
    "id": "64",
    "title": "1С:Предприятие 8. Зарплата и кадры для государственных организаций Казахстана (USB)",
    "price": "133 000",
    "category_id": "10",
    "date": "2024-09-11 12:37:42"
  },
  {
    "id": "65",
    "title": "1С:Комплексная автоматизация 8 для Казахстана. Редакция 2 (USB)",
    "price": "655 200",
    "category_id": "10",
    "date": "2024-09-11 12:38:09"
  },
  {
    "id": "66",
    "title": "title",
    "price": "price",
    "category_id": "category_id",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "67",
    "title": "1С:Предприятие 8. Комплект прикладных решений на 5 пользователей для Казахстана (USB)",
    "price": "323900",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "68",
    "title": "1С:Предприятие 8. Свод отчетов для Казахстана (USB)",
    "price": "715000",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "69",
    "title": "1С:Предприятие 8. Комплект специалиста по разработке и внедрению для Казахстана (продажа только для слушателей ЦСО и 1С-УЦ по предварительным заявкам)",
    "price": "17820",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "70",
    "title": "1С:Предприятие 8. Расширение для карманных компьютеров (включает лицензию на 5 КПК)",
    "price": "112750",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "71",
    "title": "1С:Предприятие 8. Управление Проектным Офисом. Основная поставка",
    "price": "170775",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "72",
    "title": "1С:Предприятие 8.2. Обновление платформы (по одному комплекту на зарегистрированную основную поставку «1С:Предприятия» версий 8.0 или 8.1(не базовых версий) при наличии действующей подписки на ИТС)",
    "price": "8280",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "73",
    "title": "1С:Предприятие 8.2 Технологическая поставка (USB)",
    "price": "81000",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "74",
    "title": "1С-Рейтинг: Управление финансами и бюджетирование для Казахстана. Включает платформу 1С:Предприятие 8",
    "price": "144000",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "75",
    "title": "Конфигурация 1С-Рейтинг: Управление финансами и бюджетирование для Казахстана",
    "price": "108000",
    "category_id": "10",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "76",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на одно рабочее место. Электронная поставка для Казахстана",
    "price": "38880",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "77",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 5 рабочих мест. Электронная поставка для Казахстана",
    "price": "134784",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "78",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 10 рабочих мест. Электронная поставка для Казахстана",
    "price": "259200",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "79",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 20 рабочих мест. Электронная поставка для Казахстана",
    "price": "492480",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "80",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 50 рабочих мест. Электронная поставка для Казахстана",
    "price": "1193320",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "81",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 100 рабочих мест. Электронная поставка для Казахстана",
    "price": "2332800",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "82",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 300 рабочих мест. Электронная поставка для Казахстана",
    "price": "6998400",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "83",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия на 500 рабочих мест. Электронная поставка для Казахстана",
    "price": "11664000",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "84",
    "title": "1С:Предприятие 8.3 ПРОФ. Лицензия на сервер. Электронная поставка для Казахстана",
    "price": "302400",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "85",
    "title": "1С:Предприятие 8.3 ПРОФ. Лицензия на сервер (x86-64). Электронная поставка для Казахстана",
    "price": "518400",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "86",
    "title": "1С:Предприятие 8.3 Сервер МИНИ на 5 подключений. Электронная поставка для Казахстана",
    "price": "103680",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "87",
    "title": "1С:Предприятие 8.3 КОРП. Лицензия на сервер (х86-64). Электронная поставка для Казахстана",
    "price": "1296000",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "88",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 1000 рабочих мест. Электронная поставка для Казахстана",
    "price": "42508800",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "89",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 500 рабочих мест. Электронная поставка для Казахстана",
    "price": "21319200",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "90",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 300 рабочих мест. Электронная поставка для Казахстана",
    "price": "12830400",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "91",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 100 рабочих мест. Электронная поставка для Казахстана",
    "price": "4320000",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "92",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 50 рабочих мест. Электронная поставка для Казахстана",
    "price": "2246400",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "93",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 20 рабочих мест. Электронная поставка для Казахстана",
    "price": "928800",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "94",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 10 рабочих мест. Электронная поставка для Казахстана",
    "price": "496800",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "95",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 5 рабочих мест. Электронная поставка для Казахстана",
    "price": "259200",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "96",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 1 рабочее место. Электронная поставка для Казахстана",
    "price": "73440",
    "category_id": "11",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "97",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 1 рабочее место (USB)",
    "price": "51840",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "98",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 5 рабочих мест (USB)",
    "price": "176256",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "99",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 10 рабочих мест (USB)",
    "price": "324864",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "100",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 20 рабочих мест (USB)",
    "price": "616896",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "101",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 50 рабочих мест (USB)",
    "price": "1431984",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "102",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 100 рабочих мест (USB)",
    "price": "2799360",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "103",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 300 рабочих мест (USB)",
    "price": "8398080",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "104",
    "title": "1С:Предприятие 8 ПРОФ. Клиентская лицензия для Казахстана на 500 рабочих мест (USB)",
    "price": "13996800",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "105",
    "title": "1С:Предприятие 8. Расширение для карманных компьютеров. Дополнительная лицензия на 1 рабочее место",
    "price": "7000",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "106",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 1 рабочее место (USB)",
    "price": "97200",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "107",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 5 рабочих мест (USB)",
    "price": "336960",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "108",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 10 рабочих мест (USB)",
    "price": "622080",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "109",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 20 рабочих мест (USB)",
    "price": "1166400",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "110",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 50 рабочих мест (USB)",
    "price": "2695680",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "111",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 100 рабочих мест (USB)",
    "price": "5184000",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "112",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 300 рабочих мест (USB)",
    "price": "15379200",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "113",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия для Казахстана на 500 рабочих мест (USB)",
    "price": "25574400",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "114",
    "title": "1С:Предприятие 8.3 ПРОФ. Лицензия на сервер для Казахстана (USB)",
    "price": "362880",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "115",
    "title": "1С:Предприятие 8.3 ПРОФ. Лицензия на сервер для Казахстана (x86-64) (USB)",
    "price": "622080",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "116",
    "title": "1С:Предприятие 8.3 КОРП. Лицензия на сервер для Казахстана (х86-64) (USB)",
    "price": "1555200",
    "category_id": "12",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "117",
    "title": "1С:Колледж ПРОФ для Казахстана. Поддержка по 1С:ИТС Отраслевой для Казахстана 2-й категории",
    "price": "412000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "118",
    "title": "1С:Предприятие 8. Бухгалтерия сельскохозяйственного предприятия для Казахстана. Электронная поставка",
    "price": "237600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "119",
    "title": "1С:Предприятие 8. Бухгалтерия сельскохозяйственного предприятия для Казахстана. Комплект на 5 пользователей. Электронная поставка",
    "price": "356400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "120",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 1 рабочее место. Электронная поставка",
    "price": "35100",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "121",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 5 рабочих мест. Электронная поставка",
    "price": "144000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "122",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 10 рабочих мест. Электронная поставка",
    "price": "277200",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "123",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 20 рабочих мест. Электронная поставка",
    "price": "532800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "124",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 50 рабочих мест. Электронная поставка",
    "price": "1278000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "125",
    "title": "1С:Предприятие 8. Бухгалтерия сельскохозяйственного предприятия для Казахстана. Основная поставка",
    "price": "237600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "126",
    "title": "1С:Предприятие 8. Бухгалтерия сельскохозяйственного предприятия для Казахстана для 5 пользователей",
    "price": "356400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "127",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 1 рабочее место",
    "price": "35100",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "128",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 5 рабочих мест",
    "price": "144000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "129",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 10 рабочих мест",
    "price": "277200",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "130",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 20 рабочих мест",
    "price": "532800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "131",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 50 рабочих мест",
    "price": "1278000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "132",
    "title": "1С:Предприятие 8. Бухгалтерия сельскохозяйственного предприятия для Казахстана. Основная поставка(USB)",
    "price": "285120",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "133",
    "title": "1С:Предприятие 8. Бухгалтерия сельскохозяйственного предприятия для Казахстана для 5 пользователей (USB)",
    "price": "427680",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "134",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 1 рабочее место (USB)",
    "price": "42120",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "135",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 5 рабочее место (USB)",
    "price": "172800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "136",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 10 рабочее место (USB)",
    "price": "332640",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "137",
    "title": "1С:Предприятие 8. Аптека для Казахстана. Электронная поставка",
    "price": "117000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "138",
    "title": "1С:Аптека для Казахстана. Клиентская лицензия на 1 рабочее место. Электронная поставка",
    "price": "38880",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "139",
    "title": "1С:Аптека для Казахстана. Клиентская лицензия на 5 рабочих мест. Электронная поставка",
    "price": "134784",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "140",
    "title": "1С:Аптека для Казахстана",
    "price": "117000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "141",
    "title": "1С:Аптека для Казахстана, клиентская лицензия на 1 рабочее место",
    "price": "38880",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "142",
    "title": "1С:Аптека для Казахстана, клиентская лицензия на 5 рабочих мест",
    "price": "134784",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "143",
    "title": "1С:Аптека для Казахстана (USB)",
    "price": "140400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "144",
    "title": "1С:Аптека для Казахстана, клиентская лицензия на 1 рабочее место (USB)",
    "price": "46544",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "145",
    "title": "1С:Аптека для Казахстана, клиентская лицензия на 5 рабочих мест (USB)",
    "price": "155248",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "146",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана. Электронная поставка",
    "price": "158400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "147",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана. Комплект на 5 пользователей. Электронная поставка",
    "price": "237600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "148",
    "title": "1С:Бухгалтерия предприятия пищевой промышленности для Казахстана. Клиентская лицензия на 1 рабочее место. Электронная поставка",
    "price": "23400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "149",
    "title": "1С:Бухгалтерия предприятия пищевой промышленности для Казахстана. Клиентская лицензия на 5 рабочих мест. Электронная поставка",
    "price": "96000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "150",
    "title": "1С:Бухгалтерия предприятия пищевой промышленности для Казахстана. Клиентская лицензия на 10 рабочих мест. Электронная поставка",
    "price": "184800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "151",
    "title": "1С:Бухгалтерия предприятия пищевой промышленности для Казахстана. Клиентская лицензия на 20 рабочих мест. Электронная поставка",
    "price": "355200",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "152",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана",
    "price": "158400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "153",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана. Комплект на 5 пользователей",
    "price": "237600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "154",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана, клиентская лицензия на 1 рабочее место",
    "price": "23400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "155",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана, клиентская лицензия на 5 рабочих мест",
    "price": "96000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "156",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана, клиентская лицензия на 10 рабочих мест",
    "price": "184800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "157",
    "title": "1С:Предприятие 8. Бухгалтерия предприятия пищевой промышленности для Казахстана, клиентская лицензия на 20 рабочих мест",
    "price": "355200",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "158",
    "title": "1С:Предприятие 8. Бухгалтерия строительной организации для Казахстана. Электронная поставка",
    "price": "126000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "159",
    "title": "1С:Предприятие 8. Бухгалтерия строительной организации для Казахстана. Электронная поставка на 5 пользователей",
    "price": "254000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "160",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 1 рабочее место. Электронная поставка",
    "price": "25410",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "161",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 5 рабочих мест. Электронная поставка",
    "price": "118800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "162",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 10 рабочих мест. Электронная поставка",
    "price": "224400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "163",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 20 рабочих мест. Электронная поставка",
    "price": "430860",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "164",
    "title": "1С:Бухгалтерия строительной организации для Казахстана",
    "price": "126000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "165",
    "title": "1С:Предприятие 8. Бухгалтерия строительной организации для Казахстана. Поставка на 5 пользователей",
    "price": "254000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "166",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 1 рабочее место",
    "price": "25410",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "167",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 5 рабочих мест",
    "price": "118800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "168",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 10 рабочих мест",
    "price": "224400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "169",
    "title": "1С:Бухгалтерия строительной организации для Казахстана. Клиентская лицензия на 20 рабочих мест",
    "price": "430860",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "170",
    "title": "1С:Предприятие 8. CRM ПРОФ для Казахстана. Основная поставка",
    "price": "54000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "171",
    "title": "1С:Предприятие 8. CRM СТАНДАРТ для Казахстана. Комплект на 5 пользователей",
    "price": "120600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "172",
    "title": "1С:Предприятие 8. CRM ПРОФ для Казахстана. Дополнительная лицензия на 1 рабочее место",
    "price": "27000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "173",
    "title": "1С:Предприятие 8. CRM ПРОФ для Казахстана. Многопользовательская лицензия на 5 рабочих мест",
    "price": "126000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "174",
    "title": "1С:Предприятие 8. CRM ПРОФ для Казахстана. Многопользовательская лицензия на 10 рабочих мест",
    "price": "234000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "175",
    "title": "1С:Предприятие 8. CRM ПРОФ для Казахстана. Многопользовательская лицензия на 20 рабочих мест",
    "price": "450000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "176",
    "title": "1С:Предприятие 8. CRM ПРОФ для Казахстана. Многопользовательская лицензия на 50 рабочих мест",
    "price": "1080000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "177",
    "title": "1С:CRM ПРОФ для Казахстана. Модуль для 1С:УТ. Поддержка по 1С:ИТС Отраслевой для Казахстана 1-й категории",
    "price": "67500",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "178",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана. Клиентская лицензия на 50 рабочих мест (USB)",
    "price": "1533600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "179",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана. Клиентская лицензия на 20 рабочих мест (USB)",
    "price": "639360",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "180",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 10 рабочих мест (USB)",
    "price": "332640",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "181",
    "title": "1С:Бухгалтерия сельскохозяйственного предприятия для Казахстана, клиентская лицензия на 5 рабочих мест (USB)",
    "price": "172800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "182",
    "title": "1С:Предприятие 8.CRM КОРП для Казахстана. Поддержка по 1С:ИТС Отраслевой для Казахстана 2-й категории",
    "price": "86400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "183",
    "title": "1С:CRM КОРП для Казахстана. Клиентская лицензия на 1 рабочее место",
    "price": "37800",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "184",
    "title": "1С:CRM КОРП для Казахстана. Клиентская лицензия на 5 рабочих мест",
    "price": "176400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "185",
    "title": "1С:CRM КОРП для Казахстана. Клиентская лицензия на 10 рабочих мест",
    "price": "327600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "186",
    "title": "1С:CRM КОРП для Казахстана. Клиентская лицензия на 20 рабочих мест",
    "price": "630000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "187",
    "title": "1С:CRM КОРП для Казахстана. Клиентская лицензия на 50 рабочих мест",
    "price": "1512000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "188",
    "title": "1С:CRM КОРП для Казахстана. Клиентская лицензия на 100 рабочих мест",
    "price": "2721600",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "189",
    "title": "1С:CRM КОРП для Казахстана. Модуль для 1С:УТ. Поддержка по 1С:ИТС Отраслевой для Казахстана 2-й категории",
    "price": "108000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "190",
    "title": "1С:CRM КОРП для Казахстана. Модуль для 1С:КА2 и 1С:ERP. Поддержка по 1С:ИТС Отраслевой для Казахстана 2-й категории",
    "price": "259200",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "191",
    "title": "1С:Предприятие 8. ITIL Управление информационными технологиями предприятия СТАНДАРТ. Поддержка по 1С:ИТС Отраслевой для Казахстана 1 категории",
    "price": "77280",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "192",
    "title": "1С:Предприятие 8. ITIL Управление информационными технологиями Предприятия ПРОФ. Поддержка по 1С:ИТС Отраслевой для Казахстана 2-й категории",
    "price": "399168",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "193",
    "title": "1С:Библиотека для Казахстана",
    "price": "120000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "194",
    "title": "1С:Медицина для Казахстана. Больница",
    "price": "396000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "195",
    "title": "1С:Медицина для Казахстана. Поликлиника",
    "price": "168000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "196",
    "title": "1С:Предприятие 8. Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Электронная поставка",
    "price": "150500",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "197",
    "title": "1С:Предприятие 8. Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Электронная поставка на 5 пользователей",
    "price": "307000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "198",
    "title": "1С:Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Базовая версия. Электронная поставка",
    "price": "96000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "199",
    "title": "1С:Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Клиентская лицензия на 1 рабочее место. Электронная поставка",
    "price": "32400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "200",
    "title": "1С:Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Клиентская лицензия на 5 рабочих мест. Электронная поставка",
    "price": "112300",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "201",
    "title": "1С:Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Клиентская лицензия на 10 рабочих мест. Электронная поставка",
    "price": "216000",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "202",
    "title": "1С:Бухгалтерия ОСИ, ПТ, УК, СК, КСК для Казахстана. Клиентская лицензия на 20 рабочих мест. Электронная поставка",
    "price": "410400",
    "category_id": "13",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "203",
    "title": "1С:Предприятие 8. Клиентская лицензия на 1 рабочее место (программная защита)",
    "price": "38880",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "204",
    "title": "1С:Предприятие 8. Клиентская лицензия на 5 рабочих мест (программная защита)",
    "price": "134784",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "205",
    "title": "1С:Предприятие 8. Клиентская лицензия на 10 рабочих мест (программная защита)",
    "price": "259200",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "206",
    "title": "1С:Предприятие 8. Клиентская лицензия на 20 рабочих мест (программная защита)",
    "price": "492480",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "207",
    "title": "1С:Предприятие 8. Клиентская лицензия на 50 рабочих мест (программная защита)",
    "price": "1193320",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "208",
    "title": "1С:Предприятие 8. Клиентская лицензия на 100 рабочих мест (программная защита)",
    "price": "2332800",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "209",
    "title": "1С:Предприятие 8. Клиентская лицензия на 300 рабочих мест (программная защита)",
    "price": "6998400",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "210",
    "title": "1С:Предприятие 8. Клиентская лицензия на 500 рабочих мест (программная защита)",
    "price": "11664000",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "211",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на одно рабочее место",
    "price": "73440",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "212",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 5 рабочих мест",
    "price": "259200",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "213",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 10 рабочих мест",
    "price": "496800",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "214",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 20 рабочих мест",
    "price": "928800",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "215",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 50 рабочих мест",
    "price": "2246400",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "216",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 100 рабочих мест",
    "price": "4320000",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "217",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 300 рабочих мест",
    "price": "12830400",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "218",
    "title": "1С:Предприятие 8 КОРП Клиентская лицензия на 500 рабочих мест",
    "price": "21319200",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "219",
    "title": "1С:Предприятие 8 КОРП. Клиентская лицензия на 1000 рабочих мест",
    "price": "42508800",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "220",
    "title": "1С:Предприятие 8.3 Лицензия на сервер",
    "price": "302400",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "221",
    "title": "1С:Предприятие 8.3 Лицензия на сервер(x86-64)",
    "price": "518400",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "222",
    "title": "1С:Предприятие 8.3 КОРП Лицензия на сервер(x86-64)",
    "price": "1296000",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "223",
    "title": "1С:Предприятие 8.3. Сервер МИНИ на 5 подключений",
    "price": "103680",
    "category_id": "14",
    "date": "0000-00-00 00:00:00"
  },
  {
    "id": "224",
    "title": "1С:Комплексная автоматизация 8 для Казахстана на 10 пользователей + клиент-сервер. Редакция 2 (USB)",
    "price": "1 170 000",
    "category_id": "10",
    "date": "2024-09-11 16:01:36"
  }
]
